














import { Component, Vue } from 'vue-property-decorator'
import { Admin } from '@/api'

@Component({
  components: {
    PaymentProviderListItem: () => import('./PaymentProviderListItem.vue')
  }
})
export default class PaymentProviders extends Vue {
  paymentProviders: any[] = []

  async mounted() {
    try {
      this.paymentProviders = await Admin.getPaymentProviders()
    } catch(e) {
      console.error('Cannot fetch root payment providers', e)
    }
  }
}
